<template>
  <div
    class="flex flex-col justify-center min-h-screen py-12 overflow-auto transition ease-in-out bg-light-screen-background dark:bg-dark-screen-background sm:px-6 lg:px-8 duration-side-menu-transition-duration">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <span class="flex justify-center w-full" @click="$router.push('/')">
        <LogoText :dark-mode="$store.state.ui.darkMode" />
      </span>
      <h2 class="mt-6 text-3xl font-semibold text-center text-gray-600 dark:text-gray-400">
        {{ $t("Sign up to RevSetter") }}
      </h2>
    </div>
    <div class="container mt-8 sm:mx-auto sm:w-full sm:max-w-lg">
      <Transition name="slide-left" mode="out-in">
        <div v-if="!is_logged_with_google" class="mt-8 element sm:mx-auto sm:w-full sm:max-w-lg">
          <div class="px-4 py-8 pt-2 bg-white shadow dark:bg-dark-box-background sm:rounded-lg sm:px-10">
            <Form :validation-schema="schema" class="p-3 mt-2 space-y-5" @submit="onSubmit">
              <div class="grid grid-cols-2 gap-4">
                <TextInput
                  name="first_name"
                  type="text"
                  :validate-on-input="true"
                  :debounce="800"
                  :show-success-check-mark="true"
                  label="First Name"
                  placeholder="First Name" />
                <TextInput
                  name="last_name"
                  type="text"
                  :show-success-check-mark="true"
                  :label="$t('Last Name')"
                  :placeholder="$t('Last Name')" />
              </div>
              <TextInput
                name="email"
                type="email"
                :show-success-check-mark="true"
                :show-pending-status="true"
                :validate-on-input="true"
                :debounce="800"
                :label="$t('Company email')"
                :placeholder="$t('Company email')" />

              <TextInput
                name="organization"
                type="text"
                :show-success-check-mark="true"
                :validate-on-input="true"
                :debounce="800"
                :label="$t('Company name')"
                :placeholder="$t('Company name')" />

              <TextInput
                name="password"
                autocomplete="new-password"
                :show-success-check-mark="true"
                :validate-on-input="true"
                type="password"
                :label="$t('Password')"
                :placeholder="$t('Type Your new password')" />
              <TextInput
                name="re-password"
                :show-success-check-mark="true"
                :validate-on-input="true"
                type="password"
                :label="$t('ReType password')"
                :placeholder="$t('Re-Type Your new password')" />
              <VueRecaptcha
                v-if="env == 'production'"
                sitekey="6LecENEjAAAAANi-IOCx6K_dGJl-AgX5y_bnBTKs"
                :load-recaptcha-script="true"
                @verify="
                  () => {
                    prevent_post = false
                  }
                "
                @error="
                  () => {
                    prevent_post = true
                  }
                " />

              <button id="submit" :disabled="is_submitting || (prevent_post && env == 'production')" type="submit" class="primary-btn">
                <RotateCw
                  :class="{ 'animate-spin': is_submitting, 'opacity-100': is_submitting }"
                  class="w-5 h-5 mr-3 -ml-1 opacity-0"
                  aria-hidden="true" />
                <span class="mr-5"> {{ $t("Create your Account") }} </span>
              </button>
              <div class="px-2 py-2 text-center bg-white border border-gray-200 dark:bg-dark-box-background dark:border-gray-500">
                <p class="text-xs leading-5 text-common-grey">
                  {{ $t("By signing up, you agree to our") }}
                  <router-link to="terms-and-conditions" class="pl-2 font-medium text-gray-900 dark:text-gray-300 hover:underline">
                    {{ $t("Terms and Conditions") }}
                  </router-link>
                  ,
                  <router-link to="privacy-policy" class="p-2 font-medium text-gray-900 dark:text-gray-300 hover:underline">
                    {{ $t("Data Policy") }}
                  </router-link>
                  {{ $t("and") }}
                  <router-link to="cookies-policy" class="pl-2 font-medium text-gray-900 dark:text-gray-300 hover:underline">
                    {{ $t("Cookies Policy") }}
                  </router-link>
                  .
                </p>
              </div>
              <div class="w-full">
                <button
                  type="button"
                  class="w-full max-w-md px-6 py-1 mt-4 text-base font-medium text-gray-700 bg-white border-2 border-gray-500 rounded-md shadow outline-none h-11 dark:bg-gray-300 hover:bg-blue-50 hover:border-blue focus:outline-none"
                  @click="continueWithGoogle">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="inline w-4 h-4 mr-3 text-gray-900 fill-current"
                    viewBox="0 0 48 48"
                    width="48px"
                    height="48px">
                    <path
                      fill="#fbc02d"
                      d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12 s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20 s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
                    <path
                      fill="#e53935"
                      d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039 l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
                    <path
                      fill="#4caf50"
                      d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36 c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
                    <path
                      fill="#1565c0"
                      d="M43.611,20.083L43.595,20L42,20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571 c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" /></svg>Signup with Google
                </button>
              </div>
              <div class="mt-6">
                <div class="relative">
                  <div class="absolute inset-0 flex items-center">
                    <div class="w-full border-t border-gray-300 dark:border-common-grey" />
                  </div>
                  <div class="relative flex justify-center text-sm">
                    <span class="px-2 text-gray-500 bg-white dark:bg-dark-box-background dark:text-common-grey">{{ $t("have an account ?") }}
                    </span>
                  </div>
                </div>

                <div class="grid grid-cols-1 mt-2">
                  <router-link
                    to="/login"
                    class="inline-flex items-center justify-center px-4 py-2 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm dark:bg-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-blue">
                    {{ $t("Login") }}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-5 h-5 ml-3 -mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                    </svg>
                  </router-link>
                </div>
              </div>
            </Form>
          </div>
        </div>
        <div v-else class="mt-8 element sm:mx-auto sm:w-full sm:max-w-lg">
          <div class="px-4 py-8 pt-2 bg-white shadow dark:bg-dark-box-background sm:rounded-lg sm:px-10">
            <h2 class="mx-3 mt-6 font-semibold text-left text-gray-400 text-md">
              {{ $t("Your company name") }}
            </h2>
            <Form
              :validation-schema="schema_google_login"
              :initial-values="user_google_data"
              class="p-3 mt-0 space-y-5"
              @submit="onSubmitSocial">
              <div class="sm:mt-0 sm:col-span-2">
                <div class="flex max-w-lg rounded-md shadow-sm">
                  <span
                    class="inline-flex items-center px-3 text-gray-500 border border-r-0 border-gray-300 rounded-l-md bg-gray-50 dark:bg-gray-300 sm:text-sm">
                    revsetter.com/
                  </span>
                  <TextInput
                    classes="flex-1 block w-full mt-0"
                    name="organization"
                    type="text"
                    :label="$t('Company name')"
                    :placeholder="$t('Company name')" />
                  <VueRecaptcha
                    v-if="env == 'production'"
                    sitekey="6LecENEjAAAAANi-IOCx6K_dGJl-AgX5y_bnBTKs"
                    :load-recaptcha-script="true"
                    @verify="
                      () => {
                        prevent_post = false
                      }
                    "
                    @error="
                      () => {
                        prevent_post = true
                      }
                    " />
                </div>
              </div>

              <button :disabled="is_submitting || (prevent_post && env == 'production')" type="submit" class="mt-3 primary-btn">
                <RotateCw
                  :class="{ 'animate-spin': is_submitting, 'opacity-100': is_submitting }"
                  class="w-5 h-5 mr-3 -ml-1 opacity-0"
                  aria-hidden="true" />
                <span class="mr-5"> {{ $t("Create your company") }} </span>
              </button>

              <div class="px-2 py-2 text-center bg-white border border-gray-200 dark:bg-dark-box-background dark:border-gray-500">
                <p class="text-xs leading-5 text-common-grey">
                  {{ $t("By signing up, you agree to our") }}
                  <router-link to="terms-and-conditions" class="pl-2 font-medium text-gray-900 dark:text-gray-300 hover:underline">
                    {{ $t("Terms and Conditions") }}
                  </router-link>
                  ,
                  <router-link to="privacy-policy" class="p-2 font-medium text-gray-900 dark:text-gray-300 hover:underline">
                    {{ $t("Data Policy") }}
                  </router-link>
                  {{ $t("and") }}
                  <router-link to="cookies-policy" class="pl-2 font-medium text-gray-900 dark:text-gray-300 hover:underline">
                    {{ $t("Cookies Policy") }}
                  </router-link>
                  .
                </p>
              </div>
            </Form>
          </div>
        </div>
      </Transition>
    </div>
    <TransitionRoot as="template" :show="invalid_info">
      <Dialog as="div"
              static
              class="fixed inset-0 z-10 overflow-y-auto"
              :open="invalid_info"
              @close="invalid_info = false">
        <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in duration-200"
            leave-from="opacity-100"
            leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
              class="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div class="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                <div class="sm:flex sm:items-start">
                  <div
                    class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                    <TriangleAlert class="w-6 h-6 text-red-600" aria-hidden="true" />
                  </div>
                  <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">
                      {{ $t("This email already exists") }}
                    </DialogTitle>
                    <div class="mt-2">
                      <p class="text-sm text-gray-500">
                        {{ $t("You can not signup, already have an account") }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  ref="cancelButtonRef"
                  type="button"
                  class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-light sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  @click="invalid_info = false">
                  {{ $t("Cancel") }}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
    <TransitionRoot as="template" :show="invalid_info">
      <Dialog as="div"
              static
              class="fixed inset-0 z-10 overflow-y-auto"
              :open="invalid_info"
              @close="invalid_info = false">
        <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in duration-200"
            leave-from="opacity-100"
            leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
              class="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div class="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                <div class="sm:flex sm:items-start">
                  <div
                    class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                    <TriangleAlert class="w-6 h-6 text-red-600" aria-hidden="true" />
                  </div>
                  <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">
                      {{ $t("Invalid information") }}
                    </DialogTitle>
                    <div class="mt-2">
                      <p class="text-sm text-gray-500">
                        {{ $t("Please make sure you entered valid information") }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  ref="cancelButtonRef"
                  type="button"
                  class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-light sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  @click="invalid_info = false">
                  {{ $t("Cancel") }}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script>
import * as Yup from "yup"
import { Form } from "vee-validate"
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue"
import { RotateCw, TriangleAlert } from "lucide-vue-next"
import TextInput from "@/components/shared/TextInput.vue"
import LogoText from "@/components/shared/LogoText.vue"
import { googleTokenLogin } from "vue3-google-login"
import authService from "@/services/auth.service"
import { VueRecaptcha } from "vue-recaptcha"

export default {
  name: "Signup",

  components: {
    VueRecaptcha,
    LogoText,
    TextInput,
    Form,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    RotateCw,
    TriangleAlert
  },

  data() {
    return {
      invalid_info: false,
      is_submitting: false,
      schema_google_login: null,
      schema: null,
      env: import.meta.NODE_ENV,
      prevent_post: true,
      is_logged_with_google: false,
      user_google_data: {
        organization: null
      }
    }
  },
  created() {
    if (import.meta.NODE_ENV == "production") {
      this.prevent_post = true
    } else {
      this.prevent_post = false
    }
    this.schema_google_login = Yup.object().shape({
      organization: Yup.string()
        .matches(/^[a-zA-Z0-9-]+$/, this.$t("Company name cant contain only Letters,Numbers and Hyphen"))
        .required(this.$t("Company name is required"))
        .test("company_unique", this.$t("This company name is already used"), this.checkOrganizationName)
    })

    this.schema = Yup.object().shape({
      first_name: Yup.string().required(this.$t("First name is required")),
      last_name: Yup.string().required(this.$t("Last name is required")),
      organization: Yup.string()
        .matches(/^[a-zA-Z0-9-]+$/, this.$t("Company name cant contain only Letters,Numbers and Hyphen"))
        .required(this.$t("Company name is required"))
        .test("company_unique", this.$t("This company name is already used"), this.checkOrganizationName),

      email: Yup.string()
        .email(this.$t("Please enter a valid email address"))
        .required(this.$t("Email is required"))
        .test("email_unique", this.$t("This email address is already used"), this.checkUserEmail),

      password: Yup.string()
        .matches(/^(?=.*[a-z])(?=.*[0-9])(?=.{8,})/, this.$t("Must be at least 8 characters and alphanumeric"))
        .required(this.$t("Password is required")),
      "re-password": Yup.string()
        .required()
        .oneOf([Yup.ref("password")], this.$t("Passwords do not match"))
    })
  },
  methods: {
    checkOrganizationName(value) {
      return authService.checkOrganizationName({ name: value }).then((result) => result.data.status != "ORGANIZATION_NAME_USED")
    },
    checkUserEmail(value) {
      return authService.checkUserEmail({ email: value }).then((result) => result.data.status != "EMAIL_USED")
    },
    onSubmitSocial(values) {
      authService.updateOrganizationName(values.organization).then(() => {
        this.$router.replace("/")
      })
    },
    continueWithGoogle() {
      googleTokenLogin().then((response) => {
        authService
          .signWithGoogle(response.access_token, {
            invite_code: this.$route.query?.invite_code
          })
          .then(({ data }) => {
            this.is_logged_with_google = true
            this.user_google_data = { organization: data.user.organization.name }
            let google_user = data.user
            this.$store.commit("auth/loginSuccess", google_user)
            if (data.user.is_onboarding_done) {
              window.location.href = "/"
            }
          })
      })
    },
    onSubmit(values) {
      if (!this.prevent_post) {
        this.is_submitting = true
        let data

        data = { ...values }

        this.$store.dispatch("ui/showLoading")
        data["organization"] = { name: data["organization"] }
        fetch(`${import.meta.env.VITE_BASE_API_URL}/api/users/?invite_code=${this.$route.query?.invite_code}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        })
          .then((res) => res.json())
          .then((res) => {
            this.is_submitting = false
            this.$store.dispatch("ui/hideLoading")
            if (res.code != "BAD_REQUEST") {
              this.$store.commit("auth/loginSuccess", res)
              window.location.href = "/onboarding"
            } else {
              Object.keys(res.errors).forEach((key) => {
                if (key == "organization") {
                  this.invalid_info = true
                } else {
                  this.invalid_info = true
                }
              })
            }
          })
          .catch(() => {
            this.$store.dispatch("ui/hideLoading")
            this.is_submitting = false
            this.invalid_info = true
          })
      }
    }
  }
}
</script>
<style scoped>
.container {
  display: inline-block;
  position: relative;
  justify-content: center;
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.2s ease-out;
}

.slide-left-enter-from {
  opacity: 0;
  transform: translateX(10px);
}

.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}
</style>
